'use strict'
import _ from 'lodash'
import moment from 'moment'
import configurazioni from '@/services/configurazioniService.js'
import router from '@/router'

const stampaReport = async (context, event) => {
  const payload = event.value
  const nomeReport = payload.nomeReport
  const stampaDef = payload.stampaDefault
  const filtroPostazione = !!payload.filtroPostazione
  const stampe = await configurazioni.getConfigurazione('report', 'report')
  const stampa = stampe.find(x => x.nomeReport === nomeReport)
  if (!stampa) return

  let start = 'ddd'
  let stop = 'aaa'
  const dataDa = payload.dataDa
  if (dataDa && dataDa.startsWith('#data')) {
    // Sostituisce il valore della data attuale e verifica presenza offset
    // Es. #data-7#
    const offsetDa = dataDa.slice(5).slice(0, -1)
    start = moment().add(offsetDa || 0, 'days').format('YYYYMMDD')
  }
  const dataA = payload.dataA
  if (dataA && dataA.startsWith('#data')) {
    // Sostituisce il valore della data attuale e verifica presenza offset
    // Es. #data-7#
    const offsetA = dataA.slice(5).slice(0, -1)
    stop = moment().add(offsetA || 0, 'days').format('YYYYMMDD')
  }
  console.log(dataDa, dataA)

  let parDefault = _.get(stampa, 'stampeDefault.' + stampaDef, '')
  if (parDefault && filtroPostazione) {
    const text = Buffer.from(parDefault, 'base64').toString('ascii')
    const parametri = JSON.parse(text)
    const chiave = parametri.filtri.find(x => x.chiave === 'postazione')
    const postazione = configurazioni.getPostazione()
    if (chiave) {
      chiave.valori = [configurazioni.getPostazione()]
    }
    _.set(parametri, 'intestazione.titolo_01_sx', postazione)

    const str = JSON.stringify(parametri)
    const buff = Buffer.from(str, 'utf-8')
    parDefault = buff.toString('base64')
  }
  const pathReportPrefix = process.env.VUE_APP_service_reporting || ''
  const source = `${pathReportPrefix}/reporting/pdfm/${nomeReport}/${start}/${stop}?par=${parDefault}`
  router.push({ name: 'Pdf', params: { source: source } })
}

export default {
  stampaReport
}
